export const DEFAULT_DIFFICULTY = 21;